import * as React from 'react';
import { useState, useEffect } from 'react';

/** Material UI Packages. */
import { Box, Paper, Typography, Stack } from '@mui/material';

/** Material UI Icons. */
import ConstructionIcon from '@mui/icons-material/Construction';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';

export default function Dashboard() {
    /** Named website title. */
    useEffect(() => {
        document.title = 'Dashboard | Management';
    }, []);

    return (
        <Box sx={{ maxWidth: '97%', mt: 2, mx: 'auto', height: '90vh' }}>
            <Paper
                sx={{
                    borderRadius: 5,
                    p: 1,
                    height: 'inherit',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                }}
            >
                <Stack spacing={2} alignItems="center">
                    <ConstructionIcon sx={{ fontSize: 80, color: '#fbc02d' }} />
                    <Typography variant="h4" fontWeight={700} color="text.primary">
                        Coming Soon
                    </Typography>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <HourglassBottomIcon sx={{ color: 'text.secondary' }} />
                        <Typography variant="subtitle1" color="text.secondary">
                            This page is under construction. Stay tuned!
                        </Typography>
                    </Stack>
                </Stack>
            </Paper>
        </Box>
    );
}
